import { render } from "./PantryRadioItem.vue?vue&type=template&id=0878ba8e&ts=true"
import script from "./PantryRadioItem.vue?vue&type=script&lang=ts"
export * from "./PantryRadioItem.vue?vue&type=script&lang=ts"

import "./PantryRadioItem.vue?vue&type=style&index=0&id=0878ba8e&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__